var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCdp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.16,
    y1: 0.064,
    x2: 0.86,
    y2: 0.931,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35daa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65009a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3126",
    "data-name": "Rectangle 3126",
    width: 64,
    height: 64,
    transform: "translate(1929.23 1430.042)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_cdp",
    transform: "translate(-1929.23 -1430.042)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9055",
    "data-name": "Group 9055",
    transform: "translate(1929.229 1435.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_276",
    "data-name": "Union 276",
    d: "M4390.5,13392.777a1.407,1.407,0,0,1-1.4-1.418V13378.1a1.407,1.407,0,0,1,1.4-1.418h1.153v-1.725a9.347,9.347,0,1,1,18.691,0v1.725h1.153a1.407,1.407,0,0,1,1.395,1.418v13.264a1.407,1.407,0,0,1-1.395,1.418Zm9.1-9.484v2.87a1.4,1.4,0,1,0,2.793,0v-2.87a1.4,1.4,0,1,0-2.793,0Zm-5.156-8.34v1.725h13.1v-1.725a6.553,6.553,0,1,0-13.1,0Zm22.456,7.8a2.758,2.758,0,0,1,2.316-3.129,9.763,9.763,0,0,0-1.512-19.411h-.941a2.764,2.764,0,0,1-2.752-2.759,13,13,0,0,0-13-13.015H4401a13.05,13.05,0,0,0-13.011,13.015,2.761,2.761,0,0,1-2.756,2.759h-.937a9.763,9.763,0,0,0-1.513,19.411,2.751,2.751,0,0,1,2.313,3.129,2.77,2.77,0,0,1-2.723,2.354,2.878,2.878,0,0,1-.414-.03,15.283,15.283,0,0,1,.706-30.3,18.556,18.556,0,0,1,18.335-15.857h.014a18.521,18.521,0,0,1,18.325,15.857,15.281,15.281,0,0,1,.706,30.3,3.066,3.066,0,0,1-.417.03A2.77,2.77,0,0,1,4416.9,13382.758Z",
    transform: "translate(-4369.001 -13338.927)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCdp1);
export default __webpack_public_path__ + "static/media/ic_cdp_1.a2087b2e392a7b48fb666003de78c637.svg";
export { ForwardRef as ReactComponent };